import React, { useMemo } from 'react'
import LazyLoad from 'react-lazyload'
import styled, { keyframes } from 'styled-components'

const loading = keyframes`
    from {
      transform: translateX(-100%);
    }
    to   {
      transform: translateX(100%);
    }`

const PlaceHolderBox = styled.div`
    background: #f5f5f5;
    position: relative;
    height: ${({ height }) => height || 0}px;
    max-width: 1248px;
    width: 100%;
    margin: 10px auto;
    overflow: hidden;

    &:before {
      content: '';
      display: block;
      position: absolute;
      transform: translateX(-100%);
      bottom: 0;
      left: 0;
      right: 0;
      top: 0;
      background: linear-gradient(to right, transparent 0%, #ececec 50%, transparent 100%);
      animation: ${loading} 1.5s cubic-bezier(0.4, 0.0, 0.2, 1) infinite;
  }
`

export default function LazyLoadCP(props) {
  const {
    children,
    noLazy,
    isBot,
    height,
    fullWidth,
    placeholder,
    ...rest
  } = props

  const activePlaceholder = useMemo(() => placeholder || (
  <PlaceHolderBox
    height={height}
  />
  ), [placeholder, height])

  if (isBot || noLazy) {
    return children
  }

  return (
    <LazyLoad
      placeholder={activePlaceholder}
      {...rest}
    >
      {children}
    </LazyLoad>
  )
}
